/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p1.png',
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p2.png',
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p3.png',
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p4.png',
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p5.png',
    'https://cdn.shopify.com/s/files/1/0620/5571/0877/files/202512102-p6.png',
  ]

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  // new Swiper(".sp-btn-style1 .swiper", {
  //   spaceBetween: 10,

  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   loop: true,
  // });

  let _spswiper2 = new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    on: {
      slideChange: function (e) {
        $('#sp_btns .sp-p')
          .eq(e.realIndex)
          .addClass('sp-active')
          .siblings()
          .removeClass('sp-active')
      },
    },
  })
  // 点击切换轮播
  $('#sp_btns .sp-p').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
    _spswiper2.slideToLoop($(this).index())
  })

  let _spswiper2m = new Swiper('.sp-swiper2-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.sp-swiper-btn-next-m',
      prevEl: '.sp-swiper-btn-prev-m',
    },
    pagination: {
      el: '.sp-pagination-m',
      clickable: true,
    },
    on: {
      slideChange: function (e) {
        $('#sp_btnsm .sp-p')
          .eq(e.realIndex)
          .addClass('sp-active')
          .siblings()
          .removeClass('sp-active')
      },
    },
  })

  // 点击切换轮播
  $('#sp_btnsm .sp-p').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
    _spswiper2m.slideToLoop($(this).index())
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 0,
  })

  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('#sp-num .sp-option.active').index()
    let numOptions = $('#sp-qty .sp-option.active').index()
    let color = 1

    _index = colorOptions +  numOptions*2  +color*4
    console.log(colorOptions,numOptions,color)

    // $(".sp_product_part.sp_mobile .sp-img-p")
    //   .eq(_index)
    //   .addClass("active")
    //   .siblings()
    //   .removeClass("active");
    console.log(_index,"_index")
    _swiper.slideToLoop(_index)

    changePrice()
  })

  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;

    event.preventDefault();

    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 60 : 50;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }
  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  // 从页面获取初始单价
  let sp_price1 = parseFloat($('#sp_price1').text()) || 0
  let sp_price2 = parseFloat($('#sp_price2').text()) || 0

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  let prods = window.product
  function getCur() {
    let num = $('#sp-num div.active').attr('data-val')
    let qty = $('#sp-qty div.active').attr('data-val')
    let color = $('#sp-color div.active').attr('data-val')
    return prods.filter(item => item.option1 == num && item.option2 == qty&&item.option3 == color)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.sp_product_part .sp-price-group .off-font').html(off_font)
  }
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $("#cardNum").html(result.item_count);
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
            $(this).removeClass('sp-gray')
          })
        })
      },
      dataType: 'json',
    })

    // handleAddToCart(initNum);

    var imgs = $('.sp_product_part .swiper-slide-active').find('img')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99,
      })
      let finish
      if (document.body.clientWidth <= 1080) {
        finish = $('.sp-btn-style2.sp-fixed-bottom .sp-cart')
        var fixedBtn = $('.sp-btn-style2.sp-fixed-bottom')[0]
        var cartRect = finish[0].getBoundingClientRect()

        $(flyer).animate(
          {
            top: cartRect.top + cartRect.height / 2,
            left: cartRect.left + cartRect.width / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 问答 QA3
  $('.sp-qa3-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa3-item')
    var $answer = $currentItem.find('.sp-qa3-answer')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
    } else {
      $('.sp-qa3-item').removeClass('active')
      $('.sp-qa3-answer').slideUp(300)
      $currentItem.addClass('active')
      $answer.slideDown(300)
    }
  })

  // 移动端 Tired of Slow 轮播图无缝滚动
  ;(function initTiredCarousel() {
    var $carousel = $('.sp-tired-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)

    // 支持触摸滑动
    var startX = 0
    var scrollLeft = 0
    var isDragging = false

    $carousel.on('touchstart mousedown', function (e) {
      isDragging = true
      $carousel.css('animation-play-state', 'paused')
      startX =
        e.type === 'touchstart' ? e.originalEvent.touches[0].pageX : e.pageX
      scrollLeft = $carousel.parent().scrollLeft()
    })

    $carousel.on('touchmove mousemove', function (e) {
      if (!isDragging) return
      e.preventDefault()
      var x =
        e.type === 'touchmove' ? e.originalEvent.touches[0].pageX : e.pageX
      var walk = (startX - x) * 2
      $carousel.parent().scrollLeft(scrollLeft + walk)
    })

    $carousel.on('touchend mouseup mouseleave', function () {
      isDragging = false
      $carousel.css('animation-play-state', 'running')
    })
  })()

  // 移动端 sp-part3 菜品轮播无缝滚动（从下往上）
  ;(function initFoodCarousel() {
    var $carousel = $('.sp-part3-food-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)
  })()

  // 移动端 sp-part3 特性轮播无缝滚动（从右往左）
  ;(function initFeaturesCarousel() {
    var $carousel = $('.sp-part3-features-carousel')
    if ($carousel.length === 0) return

    // 复制一份内容实现无缝循环
    var $items = $carousel.children().clone()
    $carousel.append($items)
  })()

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    // 检查元素是否已在视口中
    const rect = gradually2.getBoundingClientRect()
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0

    if (isInViewport) {
      // 元素已在视口中，立即触发动画
      paragraph2.forEach((span, index) => {
        span.style.animation = `sp-fade-in 1s ease forwards`
        span.style.animationDelay = `${index * 0.5 + 0.5}s`
      })
    } else {
      // 元素不在视口中，使用IntersectionObserver
      const observerAni = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              paragraph2.forEach((span, index) => {
                span.style.animation = `sp-fade-in 1s ease forwards`
                span.style.animationDelay = `${index * 0.5 + 0.5}s`
              })

              observerAni.unobserve(gradually2)
            }
          })
        },
        {
          threshold: 0.1,
        }
      )
      observerAni.observe(gradually2)
    }
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // 移动端 Automatic Stirring 轮播图功能
  ;(function initAutoStirSwiper() {
    const swiperWrapper = document.querySelector('.sp-mug-auto-swiper-wrapper')
    const slides = document.querySelectorAll('.sp-mug-auto-slide')
    const dots = document.querySelectorAll('.sp-mug-auto-dot')

    if (!swiperWrapper || slides.length === 0) return

    let currentIndex = 0
    const totalSlides = slides.length
    let autoplayInterval
    const autoplayDelay = 3000 // 3秒自动切换

    // 切换到指定幻灯片
    function goToSlide(index) {
      // 处理边界情况
      if (index < 0) {
        index = totalSlides - 1
      } else if (index >= totalSlides) {
        index = 0
      }

      currentIndex = index

      // 使用transform平滑切换
      swiperWrapper.style.transition = 'transform 0.5s ease-in-out'
      swiperWrapper.style.transform = `translateX(-${currentIndex * 100}%)`

      // 更新指示器状态
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex)
      })
    }

    // 下一张
    function nextSlide() {
      goToSlide(currentIndex + 1)
    }

    // 开始自动播放
    function startAutoplay() {
      stopAutoplay()
      autoplayInterval = setInterval(nextSlide, autoplayDelay)
    }

    // 停止自动播放
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval)
        autoplayInterval = null
      }
    }

    // 指示器点击事件
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function () {
        goToSlide(index)
        // 点击后重置自动播放计时器
        startAutoplay()
      })
    })

    // 触摸滑动支持
    let touchStartX = 0
    let touchEndX = 0

    swiperWrapper.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX
        stopAutoplay()
      },
      { passive: true }
    )

    swiperWrapper.addEventListener(
      'touchmove',
      function (e) {
        touchEndX = e.touches[0].clientX
      },
      { passive: true }
    )

    swiperWrapper.addEventListener('touchend', function () {
      const diff = touchStartX - touchEndX
      const threshold = 50 // 滑动阈值

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // 向左滑动，下一张
          nextSlide()
        } else {
          // 向右滑动，上一张
          goToSlide(currentIndex - 1)
        }
      }

      startAutoplay()
    })

    // 初始化
    goToSlide(0)
    startAutoplay()
  })()

  // 移动端 Safe Materials 轮播图功能
  ;(function initSafeMaterialsMobileSwiper() {
    const swiperWrapper = document.querySelector('.sp-safe-m-swiper-wrapper')
    const slides = document.querySelectorAll('.sp-safe-m-slide')
    const leftArrow = document.querySelector('.sp-safe-m-arrow-left')
    const rightArrow = document.querySelector('.sp-safe-m-arrow-right')

    if (!swiperWrapper || slides.length === 0) return

    let currentIndex = 0
    const totalSlides = slides.length
    let autoplayInterval
    const autoplayDelay = 4000 // 4秒自动切换

    // 切换到指定幻灯片
    function goToSlide(index, smooth = true) {
      // 处理边界情况 - 无缝循环
      if (index < 0) {
        index = totalSlides - 1
      } else if (index >= totalSlides) {
        index = 0
      }

      currentIndex = index

      // 使用transform平滑切换
      if (smooth) {
        swiperWrapper.style.transition = 'transform 0.5s ease-in-out'
      } else {
        swiperWrapper.style.transition = 'none'
      }
      swiperWrapper.style.transform = `translateX(-${currentIndex * 100}%)`
    }

    // 上一张
    function prevSlide() {
      goToSlide(currentIndex - 1)
    }

    // 下一张
    function nextSlide() {
      goToSlide(currentIndex + 1)
    }

    // 开始自动播放
    function startAutoplay() {
      stopAutoplay()
      autoplayInterval = setInterval(nextSlide, autoplayDelay)
    }

    // 停止自动播放
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval)
        autoplayInterval = null
      }
    }

    // 左箭头点击事件
    if (leftArrow) {
      leftArrow.addEventListener('click', function () {
        prevSlide()
        startAutoplay() // 点击后重置自动播放计时器
      })
    }

    // 右箭头点击事件
    if (rightArrow) {
      rightArrow.addEventListener('click', function () {
        nextSlide()
        startAutoplay() // 点击后重置自动播放计时器
      })
    }

    // 触摸滑动支持
    let touchStartX = 0
    let touchEndX = 0

    swiperWrapper.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX
        stopAutoplay()
      },
      { passive: true }
    )

    swiperWrapper.addEventListener(
      'touchmove',
      function (e) {
        touchEndX = e.touches[0].clientX
      },
      { passive: true }
    )

    swiperWrapper.addEventListener('touchend', function () {
      const diff = touchStartX - touchEndX
      const threshold = 50 // 滑动阈值

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // 向左滑动，下一张
          nextSlide()
        } else {
          // 向右滑动，上一张
          prevSlide()
        }
      }

      startAutoplay()
    })

    // 初始化
    goToSlide(0)
    startAutoplay()
  })()

  // PC端 Safe Materials 轮播图功能
  ;(function initSafeMaterialsSwiper() {
    const swiperWrapper = document.querySelector('.sp-safe-swiper-wrapper')
    const slides = document.querySelectorAll('.sp-safe-slide')
    const leftArrow = document.querySelector('.sp-safe-arrow-left')
    const rightArrow = document.querySelector('.sp-safe-arrow-right')

    if (!swiperWrapper || slides.length === 0) return

    let currentIndex = 0
    const totalSlides = slides.length
    let autoplayInterval
    const autoplayDelay = 4000 // 4秒自动切换

    // 切换到指定幻灯片
    function goToSlide(index, smooth = true) {
      // 处理边界情况 - 无缝循环
      if (index < 0) {
        index = totalSlides - 1
      } else if (index >= totalSlides) {
        index = 0
      }

      currentIndex = index

      // 使用transform平滑切换
      if (smooth) {
        swiperWrapper.style.transition = 'transform 0.5s ease-in-out'
      } else {
        swiperWrapper.style.transition = 'none'
      }
      swiperWrapper.style.transform = `translateX(-${currentIndex * 100}%)`
    }

    // 上一张
    function prevSlide() {
      goToSlide(currentIndex - 1)
    }

    // 下一张
    function nextSlide() {
      goToSlide(currentIndex + 1)
    }

    // 开始自动播放
    function startAutoplay() {
      stopAutoplay()
      autoplayInterval = setInterval(nextSlide, autoplayDelay)
    }

    // 停止自动播放
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval)
        autoplayInterval = null
      }
    }

    // 左箭头点击事件
    if (leftArrow) {
      leftArrow.addEventListener('click', function () {
        prevSlide()
        startAutoplay() // 点击后重置自动播放计时器
      })
    }

    // 右箭头点击事件
    if (rightArrow) {
      rightArrow.addEventListener('click', function () {
        nextSlide()
        startAutoplay() // 点击后重置自动播放计时器
      })
    }

    // 初始化
    goToSlide(0)
    startAutoplay()
  })()
})
